import { actions, reducer as travelCollection, selectors } from './store';
export { default } from './TravelCollection';
export const store = { actions, reducers: { travelCollection }, selectors };
